import { API_BASE_URL, IS_DEVELOPMENT } from '../constants';

const DEFAULT_API_ORIGIN = 'https://api.formshive.com';
const PRODUCTION_FRONTEND_ORIGIN = 'https://formshive.com';

/**
 * The scheme, host and port of the API, without the `/v1` prefix that
 * `VITE_API_BASE_URL` carries. Swagger UI and `/mcp` are mounted there.
 */
export function apiOrigin(apiBaseUrl: string | undefined = API_BASE_URL): string {
  const raw = apiBaseUrl?.trim();
  if (!raw) return DEFAULT_API_ORIGIN;
  try {
    return new URL(raw).origin;
  } catch {
    // A relative base such as `/v1` in some dev setups: the page's own origin.
    return typeof window === 'undefined' ? DEFAULT_API_ORIGIN : window.location.origin;
  }
}

/** Where `link.html` and `embed.min.js` are served: this dev server, else formshive.com. */
export function frontendOrigin(): string {
  return IS_DEVELOPMENT && typeof window !== 'undefined'
    ? window.location.origin
    : PRODUCTION_FRONTEND_ORIGIN;
}

/** Swagger UI sits next to `/v1`, not under it. */
export function apiReferenceUrl(): string {
  return `${apiOrigin()}/swagger-ui/`;
}
